import { ContactFilterRemovedReasonTypeEnum } from 'modules/contacts/enums/contact-enum'

export const ContactFilterRemovedReasonLocoKeys: Record<
  ContactFilterRemovedReasonTypeEnum,
  string
> = {
  [ContactFilterRemovedReasonTypeEnum.manual]: 'dashboard.contacts_bin.removed_reason_type_manual',
  [ContactFilterRemovedReasonTypeEnum.sendgrid_invalid_email]:
    'dashboard.contacts_bin.removed_reason_type_sendgrid_invalid_email',
  [ContactFilterRemovedReasonTypeEnum.invalid_email]:
    'dashboard.contacts_bin.removed_reason_type_invalid_email',
  [ContactFilterRemovedReasonTypeEnum.automatically_by_condition]:
    'dashboard.contacts_bin.removed_reason_type_automatically_by_condition',
  [ContactFilterRemovedReasonTypeEnum.automatically_from_sio_students]:
    'dashboard.contacts_bin.removed_reason_type_automatically_from_sio_students',
  [ContactFilterRemovedReasonTypeEnum.not_confirmed]:
    'dashboard.contacts_bin.removed_reason_type_not_confirmed',
}
